/**
 * Libellé et rang d'un poste, partagés par les écrans qui regroupent des
 * sous-postes ou des lignes d'exécution par poste (Sous-postes, À arbitrer,
 * Règles, Exercice).
 */

import { A_CLASSER, A_CLASSER_RECETTES, NOMENCLATURE, POSTE_HORS_BUDGET, libellePoste } from '@scc/core';

/** Libellé d'un poste de la nomenclature, de « Hors budget » ou de la ligne « À classer ». */
export const libellePosteOuHorsBudget = (poste: string): string =>
  poste === POSTE_HORS_BUDGET ? 'Hors budget' : libellePoste(poste);

/** Rang d'un poste : nomenclature votée dans son ordre, puis les inconnus, « Hors budget », « À classer ». */
export function rangPoste(poste: string): number {
  const p = NOMENCLATURE.find((x) => x.code === poste);
  if (p) return p.ordre;
  if (poste === A_CLASSER || poste === A_CLASSER_RECETTES) return Number.MAX_SAFE_INTEGER;
  return poste === POSTE_HORS_BUDGET ? Number.MAX_SAFE_INTEGER - 1 : Number.MAX_SAFE_INTEGER - 2;
}
